import React from "react";

type AlertMessageProps = {
  open: boolean;
  messages: string[];
}


const AlertMessages: React.FC<AlertMessageProps> = ({open, messages}) => {
  const alertMessages = messages.length === 0 ? '' : messages.map((message: string) =>
    <li>{message}</li>
  )

  return (
    <React.Fragment>
      { open &&
        <div className="contact-note">
          <ul>
            {alertMessages}
          </ul>
        </div>
      }
    </React.Fragment>
  )
}


export default AlertMessages;